import YDropdownItem from './DropdownItem';

export { YDropdownItem };
export default YDropdownItem;
